<template>
  <div class="w100">
    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="header">
        <el-image
          class="header-img "
          :src="type == 1 ? planBanner : courseBanner"
          :fit="cover"></el-image>
      </div>
      <div class="content flexVC">
        <div class="title">{{type == 1 ? '趁早计划' : '趁早课程'}}</div>
        <div class="w100 flexWrap marB50">
          <div class="item marL15 marB20" v-for="item in listData" @click="navLink(item.link)">
            <el-image
              class="item-img "
              :src="item.coverUrl"
              :fit="cover"></el-image>
            <div class="item-title marL20 marT10">{{item.title}}</div>
            <div class="item-subtitle marT5 marL20">{{item.subtitle}}</div>
            <div class="item-line marT10"></div>
            <div class="w100 flexHC marT15">
              <div class="item-tag flexHC2" :class="childIndex == 0 ? 'marL20 marR5' :'marR5'"
                   v-for="(child,childIndex) in item. tag">{{child}}
              </div>
            </div>
          </div>
          <div class="item-empty marL15" v-for="count in 6"></div>
        </div>
      </div>
      <shape-fotter></shape-fotter>
    </div>
    <div class="w100 flexVC" v-if="!$store.state.isPc">
      <div class="header-m">
        <el-image
          class="header-img-m "
          :src="type == 1 ? planBanner : courseBanner"
          :fit="cover"></el-image>
      </div>
      <div class="content-m flexVC">
        <div class="title-m">{{type == 1 ? '趁早计划' : '趁早课程'}}</div>
        <div class="item-box-m marT32m flexH" :style="type == 1 ? ' width: 6.7rem;;' : ' width: 6.7rem;;'"  v-for="item in listData" @click="navLink(item.link)">
          <el-image
            class="item-img-m   marT20m marL20m"
            :src="item.coverUrl"
            :fit="cover"></el-image>
          <div class="marL30m">
            <div class="item-title-m marT15m">{{item.title}}</div>
            <div class="item-num-m marT10m fontE1">{{item.subtitle}}</div>
            <div class="flexHC ">
              <div class="item-tag-m flexHC2"
                   v-for="(child,childIndex) in item. tag">{{child}}</div>
            </div>
          </div>
        </div>

      </div>
      <shape-fotter></shape-fotter>
    </div>
  </div>
</template>

<script>
  import shapeFotter from '@/components/ShapeFooter'
  import {courseData, programData} from '@/utils/staticData'

  export default {
    name: "CollegeDetail",
    data() {
      return {
        content: '趁早读书会是由创始人王潇于2014年4月23日世界读书日发起，全球各城市自发申请组建的“趁早”线下交流平台，旨在帮助大家遇见彼此，共同学习与见证，分享提升，做更多有意义的事。',
        isShow: true,
        cover: 'cover',
        listData: [],
        courseBanner: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/con_mock_banner_2.png',
        planBanner: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/icon_mock_banner_1.png',
        type: 1,
        testImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%92%8C%E6%BD%87%E6%B4%92%E5%A7%90%E5%A1%91%E8%BA%AB100%E5%A4%A9.jpg',
      }
    },

    components: {
      shapeFotter,
    },

    mounted() {
      window.scrollTo(0, 0);
      this.type = this.$route.query.type
      this.listData = this.$route.query.type == 1 ? programData : courseData
    },

    watch: {
      '$route': function (newUrl, oldUrl) {
        if (newUrl != oldUrl) {
          this.type = this.$route.query.type
        }
      }
    },
    methods: {
      navLink(link) {
        if (!link) {
          return
        }
        // window.location.href = link
        window.open(link, '_blank')
      }
    }

  }
</script>

<style scoped>

  .header {
    width: 100%;
    height: 462px;
  }

  .header-img {
    width: 100%;
    height: 462px;
  }

  .content {
    width: calc(100% - 7.71vw - 7.71vw);
  }

  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 80px;
    margin-bottom: 50px;
  }

  .item-empty {
    width: 298px;
    height: 15px;
  }

  .item {
    width: 298px;
    height: 420px;
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 4px 4px;
    cursor: pointer;
  }

  .item-img {
    width: 298px;
    height: 298px;
  }

  .item-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  .item-subtitle {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.25);
  }

  .item-line {
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, .08);
  }

  .item-tag {
    width: auto;
    height: 16px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
    padding: 0 4px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }


  /* ************************************* mobile *********************************************** */
  .header-img-m{
    width: 100%;
    height: 3rem;
  }

  .content-m{
    width: 100%;
  }

  .title-m{
    margin: 0.48rem 0;
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .item-box-m {

    height: 1.94rem;
    background: #FFFFFF;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.02), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
  }

  .item-img-m {
    width: 1.52rem;
    height: 1.52rem;
  }

  .item-title-m {
    font-size: 0.28rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  .item-tag-m {
    width: auto;
    height: 0.34rem;
    font-size: 0.18rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    margin-right: 0.12rem;
    padding: 0 0.12rem;
    margin-top: 0.35rem;
  }

  .item-num-m {
    width: 4.2rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
  }


  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marT20m {
    margin-top: 0.2rem;
  }

  .marT15m {
    margin-top: 0.15rem;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  .marT32m {
    margin-top: 0.32rem;
  }

  .marL20m {
    margin-left: 0.2rem;
  }

  .marL30m {
    margin-left: 0.3rem;
  }

  /* ************************************************************************************ */

</style>



// WEBPACK FOOTER //
// src/page/college/CollegeDetail.vue